import { LOGOUT, SET_BID_REQUESTS, SET_OPEN_ORDERS, SET_PREVIOUS_ORDERS } from "../actionTypes";
import { SELLER_ACTION_TYPES } from "../actions/seller.action";


const initialState = {
	isLoading: false,
	bidRequests: [],
	openOrders: [],
	previousOrders: [],
	ordersInProgress: {
		totalRows: 0,
		bids: [],
	},
	pastOrders: {
		totalRows: 0,
		bids: [],
	}
};

const sellerReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_BID_REQUESTS: {
			return { ...state, bidRequests: action.payload };
		}

		case SET_OPEN_ORDERS: {
			return { ...state, openOrders: action.payload };
		}

		case SET_PREVIOUS_ORDERS: {
			return { ...state, previousOrders: action.payload };
		}

		case LOGOUT: {
			return { ...state, bidRequests: [], openOrders: [], previousOrders: [] };
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS: {
			return { ...state, isLoading: true }
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			newState.ordersInProgress.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ERROR: {
			return { ...state, isLoading: false }
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE: {
			return state;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_ON_PAGE_CHANGE_ERROR: {
			return state;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE: {
			return state;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_PER_PAGE_LIMIT_CHANGE_ERROR: {
			return state;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY: {
			return { ...state, isLoading: true }
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_DONE: {
			const newState = structuredClone(state);
			newState.ordersInProgress.bids = action.payload.paginationData;
			newState.ordersInProgress.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR: {
			return { ...state, isLoading: false };
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS: {
			return { ...state, isLoading: true }
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			newState.pastOrders.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ERROR: {
			return { ...state, isLoading: false }
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE: {
			return state;
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_ON_PAGE_CHANGE_ERROR: {
			return state;
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE: {
			return { ...state, isLoading: true }
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			newState.isLoading = false;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_PER_PAGE_LIMIT_CHANGE_ERROR: {
			return { ...state, isLoading: false }
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY: {
			return { ...state, isLoading: true }
		}

		case SELLER_ACTION_TYPES.GET_PREVIOUS_ORDERS_FOR_SEARCHED_QUERY_DONE: {
			const newState = structuredClone(state);
			newState.pastOrders.bids = action.payload.paginationData;
			newState.pastOrders.totalRows = action.payload.totalRecords;
			newState.isLoading = false;
			return newState;
		}

		case SELLER_ACTION_TYPES.GET_ORDERS_IN_PROGRESS_FOR_SEARCHED_QUERY_ERROR: {
			return { ...state, isLoading: false };
		}

		default:
			return state;
	}
};

export default sellerReducer;
